module.exports = __webpack_public_path__ + "static/media/Simon.7012c73f.png";